import React from 'react';
import Typography from '../../../atoms/Typography';
import Picture from '../../../atoms/Picture';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-react';
import aspectRatios from '../../../../utils/AspectRatios';
import clsx from 'clsx';
import Link from '../../../atoms/Link';
import Favorite from '../../../atoms/Favorite';
import { get } from 'lodash';
import { formatArabicLangMonth, formatTimeToAr, getUTCDateInUAEFormat } from '../../../../utils/dateTimeFunctions/dateTimeFunctions';
import { removeDashesFromString } from '../../../../utils/string-utils';

const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

const AdCarouselItem = props => {
  const { index, item, startDate, endDate, language, numberingColor = '' } = props;
  const category = get(item, 'fields.eventCategory[0].fields.taxonomyValue.value', '');
  const image = get(item, 'fields.thumbnailImageUrl', '');
  const title = get(item, 'fields.name.value', '');
  const eventStartDateTime = get(item, 'fields.eventStartDateTime.value', '')
  const eventEndDateTime = get(item, 'fields.eventEndDateTime.value', '')
  const isRtl = language === 'ar'
  const id = removeDashesFromString(get(item, 'id', ''));
  const cta = `/${language}${get(item, 'fields.ItemURL.value', '')}`;

  const startDateMonth = eventStartDateTime ? getUTCDateInUAEFormat(eventStartDateTime, 'MMM') : '';
  const startDateDay = eventStartDateTime ? getUTCDateInUAEFormat(eventStartDateTime, 'DD') : '';
  const startTime = eventStartDateTime ? getUTCDateInUAEFormat(eventStartDateTime, 'hh:mm A') : '';
  const endDateMonth = eventEndDateTime ? getUTCDateInUAEFormat(eventEndDateTime, 'MMM') : '';
  const endDateDay = eventEndDateTime ? getUTCDateInUAEFormat(eventEndDateTime, 'DD') : '';
  const endTime = eventEndDateTime ? getUTCDateInUAEFormat(eventEndDateTime, 'hh:mm A') : '';

  const time = isRtl ? `\u200F ${formatTimeToAr(endTime)} - ${formatTimeToAr(startTime)}` : `${startTime} - ${endTime}`

  const getFormattedDateAndTime = () => {
    let formattedDateAndTime = `${isRtl ? "" : (startDateMonth + ' ' + startDateDay)}`;
    if (startDateMonth === endDateMonth) {
      if (startDateDay !== endDateDay) {
        formattedDateAndTime += `${isRtl ? ('\u200F' + startDateDay + ' - ' + endDateDay + ' ') : (' - ' + endDateDay)}`;
        if (isRtl) {
          formattedDateAndTime += formatArabicLangMonth(eventEndDateTime)
          return formattedDateAndTime += (", " + time)
        }
      }
    } else {
      formattedDateAndTime += `${isRtl ? ('\u200F' + startDateDay + ' ' + formatArabicLangMonth(eventStartDateTime) + ' - ') : (' - ' + endDateMonth + ' ' + endDateDay)}`
    }
    formattedDateAndTime += `${isRtl ? ('\u200F' + endDateDay + ' ' + formatArabicLangMonth(eventEndDateTime)) : (', ' + time)}`;
    if (isRtl) formattedDateAndTime += (", " + time)
    return formattedDateAndTime;
  }
  return (
    <>
      <ConditionalWrapper
        condition={cta}
        wrapper={children => (
          <div className='slide-overlay-wrapper'>
            <p className='slideNumber-bg' style={{ color: numberingColor ? numberingColor : '' }}>{index + 1}</p>
            <Link link={{ value: { href: cta } }} draggable={false}>
              {children}
            </Link>
          </div>
        )}
      >
        <div className={clsx(props.className)}>
          <div className='slideItemsWrapper'>
            <div className='slidePictureWrapper'>
              <div className='slideElement'>
                <Picture
                  media={{
                    image: image,
                    mobileImage: image,
                    aspectRatio: aspectRatios['4x5-m'],
                    disableLazyLoad: true,
                  }}
                  isParalax={false}
                  alternateAltText={title}
                />
              </div>
            </div>
            <div className='slideInformation'>
              <div className={'slideInformationTop'}>
                {category && (
                  <div className={'categoryLabel'}>
                    <Typography variant="body2" component="p" className="categoryLabelText">
                      {category}
                    </Typography>
                  </div>
                )}
                <div className={'favouriteWrapper'}>
                  <Favorite itemUniqueKey={id} />
                </div>
              </div>
              <div className={'slideInformationBottom'}>
                {language && eventStartDateTime && eventEndDateTime && (
                  <Typography component="p" variant="body2" className="timeText">
                    <Text field={{ value: getFormattedDateAndTime() }} />
                  </Typography>
                )}
                {title && (
                  <Typography variant="body1Bold22" component="p"
                    className="sliderTitle"
                    animateSettings={{
                      willAnimate: false,
                    }}>
                    {title}
                  </Typography>
                )}
              </div>
            </div>
          </div>
        </div>
      </ConditionalWrapper>
    </>
  );
};

export default withSitecoreContext()(withNamespaces()(AdCarouselItem));
